import React from 'react';
import { BiddingDataTypes } from 'interfaces/robot_dashboard';
import moment from 'moment';

interface DataTableItem {
  clientId: number;
  edital: string;
  uasg: string;
  orgName: string;
  proposalFinalDate: string;
  disputeStartDate: string;
  status: string;
}

const EDITAL_GROW = 0;
const UASG_GROW = 0;
const ORG_NAME_GROW = 3;
const PROPOSAL_FINAL_DATE_GROW = 2;
const DISPUTE_START_DATE_GROW = 2;
const STATUS_GROW = 1;

export const datatableData = (biddingsList: Array<BiddingDataTypes>) => {
  return biddingsList.map((bidding) => {
    return {
      clientId: bidding.clientId,
      edital: bidding.prgCod || '',
      uasg: bidding.uasg || '',
      orgName: bidding.orgName || '',
      proposalFinalDate: bidding.proposalFinalDate || '',
      disputeStartDate: bidding.disputeStartDate || '',
      status: bidding.status,
    };
  });
};

export const datatableColumns = () => {
  return [
    {
      name: 'N. Pregão',
      width: '130px',
      sortable: true,
      selector: (data: DataTableItem) => data.edital,
      center: false,
      grow: EDITAL_GROW,
      cell: (data: DataTableItem) => <div>{data.edital}</div>,
    },
    {
      name: 'UASG',
      sortable: true,
      selector: (data: DataTableItem) => data.uasg,
      center: false,
      grow: UASG_GROW,
      cell: (data: DataTableItem) => <div>{data?.uasg ? data.uasg : '--'}</div>,
    },
    {
      name: 'Nome',
      sortable: true,
      selector: (data: DataTableItem) => data.orgName,
      center: false,
      grow: ORG_NAME_GROW,
      cell: (data: DataTableItem) => <div>{data.orgName}</div>,
    },
    {
      name: 'Limite Proposta',
      width: '170px',
      sortable: true,
      selector: (data: DataTableItem) => data.proposalFinalDate,
      center: false,
      grow: PROPOSAL_FINAL_DATE_GROW,
      cell: (data: DataTableItem) => (
        <div>
          {data.proposalFinalDate
            ? moment(data.proposalFinalDate).format('DD/MM/YYYY, HH:mm')
            : '--'}
        </div>
      ),
    },
    {
      name: 'Abertura de Lances',
      width: '170px',
      sortable: true,
      selector: (data: DataTableItem) => data.disputeStartDate,
      center: false,
      grow: DISPUTE_START_DATE_GROW,
      cell: (data: DataTableItem) => (
        <div>
          {data.disputeStartDate ? moment(data.disputeStartDate).format('DD/MM/YYYY, HH:mm') : '--'}
        </div>
      ),
    },
    {
      name: 'Status',
      width: '130px',
      sortable: true,
      selector: (data: DataTableItem) => data.status,
      center: false,
      grow: STATUS_GROW,
      cell: (data: DataTableItem) => (
        <div>
          {data.status === 'Cadastrada' && (
            <span className="badge badge-secondary">{data.status}</span>
          )}
          {data.status === 'Configurada' && (
            <span className="badge badge-primary">{data.status}</span>
          )}
          {data.status === 'Encerrada' && <span className="badge badge-danger">{data.status}</span>}
          {data.status === 'Em Disputa' && (
            <span className="badge badge-success">{data.status}</span>
          )}
        </div>
      ),
    },
  ];
};
